<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Gestione dati stagione', route: '/backoffice/stagione' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">GESTIONE DATI STAGIONE</h1>
</section>


<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formStagione" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">
            <div class="w-full">
                <label>* Titolo</label>
                <input type="text" pInputText placeholder="Titolo" formControlName="titolo" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formStagione.get('titolo')?.hasError('required') && (formStagione.get('titolo')?.dirty || formStagione.get('titolo')?.touched)">Il titolo è obbligatorio!.</small>
            </div>
            <div class="w-full">
                <label>Descrizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
            </div>
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <label>Testo pulsante</label>
                    <input type="text" pInputText placeholder="Testo" formControlName="button" />                    
                </div>
                <div class="lg:w-1/2 w-full">
                    <label>Link Pulsante</label>
                    <input type="text" pInputText placeholder="Link" formControlName="link" />                    
                </div>
            </div>
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <label>Testo pulsante</label>
                    <input type="text" pInputText placeholder="Testo" formControlName="button_2" />                    
                </div>
                <div class="lg:w-1/2 w-full">
                    <label>Link Pulsante</label>
                    <input type="text" pInputText placeholder="Link" formControlName="link_2" />                    
                </div>
            </div>
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <label>Testo pulsante</label>
                    <input type="text" pInputText placeholder="Testo" formControlName="button_3" />                    
                </div>
                <div class="lg:w-1/2 w-full">
                    <label>Link Pulsante</label>
                    <input type="text" pInputText placeholder="Link" formControlName="link_3" />                    
                </div>
            </div>
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <label>Testo pulsante</label>
                    <input type="text" pInputText placeholder="Testo" formControlName="button_4" />                    
                </div>
                <div class="lg:w-1/2 w-full">
                    <label>Link Pulsante</label>
                    <input type="text" pInputText placeholder="Link" formControlName="link_4" />                    
                </div>
            </div>
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/3 w-full">
                    <app-file-upload [form]="formStagione" [control]="'img_1'" [label]="'Immagine 1'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'"></app-file-upload>                    
                </div>
                <div class="lg:w-1/3 w-full">
                    <app-file-upload [form]="formStagione" [control]="'img_2'" [label]="'Immagine 2'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'"></app-file-upload>
                </div>
                <div class="lg:w-1/3 w-full">
                    <app-file-upload [form]="formStagione" [control]="'img_3'" [label]="'Immagine 3'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'"></app-file-upload>                    
                </div>
            </div>

            <div class="w-full">
                <label>Programma Stagione</label>
                <app-file-upload [form]="formStagione" [control]="'programma'" [multiple]="false" [accept]="'application/pdf'" [text]="'Seleziona il programma'"></app-file-upload>                                    
            </div>
        </div>
     
        <button class="btn-outln-backoffice p-3 w-full font-medium mt-8" type="submit" [disabled]="!formStagione.valid">Salva modifiche</button>
                    
        
    </form>
</section>